/* Next */
import Link from 'next/link'

/* Material */
import Button from '@mui/material/Button'

const VersandkostenHinweis = () => <div>
    
  <Link href='auslandsversandkosten' passHref legacyBehavior>
    <Button
      variant='text' color='secondary'
      component='a'
      sx={{ mt: 2 }}
    >
      weitere Länder
    </Button>
  </Link>

</div>

export default VersandkostenHinweis